// The 35-character ceiling applied to the return label name fields (SM-2442).
//
// Where it is DHL's rule: the sender address is the only part of the payload
// return-service forwards to tracking-service, and DHL rejects its name and
// company above this length. That covers companyName on the off-portal form,
// which becomes sender_address.company, and fullName in the portal modal, which
// becomes sender_address.name.
//
// Where it is ours: contactName on the off-portal form is capped by product
// decision, not by the carrier. It stays on the request as the requester's
// notification name and never reaches DHL. The off-portal senderName is
// deliberately left uncapped as free-form, even though it does reach the
// carrier - so an over-long value there can still fail downstream.
//
// Characters, not bytes - "TUEV SUED" style umlauts make the two diverge, and
// the SM-2442 repro accepted a 34-character / 36-byte value while rejecting a
// 41-character one, which rules out a byte limit.
//
// TODO(SM-2442): the 35 comes from the reported repro, not from a spec - the DHL
// adapter lives in tracking-service and encodes no limit we can read. Reconcile
// against the authoritative per-carrier table once published; DHL Paket DE may
// allow more than DHL Express, in which case this is the stricter of the two.
export const RETURN_LABEL_NAME_MAX_LENGTH = 35
